<script>

    import Image from "./Image.svelte";
    import {optionsStore} from "../core/app-store.js";
    import {createEventDispatcher, onMount} from "svelte";
    import {eventBus} from "../core/event-bus-store.js";
    import Price from "./Price.svelte";
    import { t } from '../core/i18n/language-store';
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;
    export let cardHeight;

    let nutritionalOpen = false;

    let media = (record?.media || []).length > 0 ? record?.media[0] : undefined;

    onMount(() => {
        if (record?.media?.length > 1 && record?.media[0]?.type === 'video') {
            for (let i = 1; i < record.media.length; i++) {
                if (record.media[i].type === 'photo') {
                    media = record.media[i];
                    break;
                }
            }
        }
    });

    const toggleDetailsScreen = (record) => {
        dispatch('toggleDetailsScreen', record);
    }

    const removeFromCartHandler = (record) => {
        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'removeItems'}}]);
        }
        else {
            dispatch('removeFromCart', record);
        }
    }

    const addToCartHandler = (record) => {

        if (record?.prices?.length > 1 || record?.mods?.length > 0) {
            eventBus.set([{event: 'openEditDetailsHalfScreen', payload: {record, mode: 'addItems'}}]);
        }
        else {
            dispatch('addToCart', record);
        }
    }

</script>
<style>

    .card {
        flex: 1 1 45%;
        min-height: 200px;
        overflow: hidden;
    }
    .card .media-block {
        position: relative;
        height: 200px;
        aspect-ratio: 4 / 5;
    }
    .card .media-block .label {
        position: absolute;
        top: 10px;
        left: 10px;
        text-transform: uppercase;
        font-family: PT Mono, sans-serif;
        font-size: 12px;
        letter-spacing: 1.2px;
        border-radius: 2rem;
        opacity: .9;
        line-height: 1;
        background: var(--bg-second-color);
        color: var(--accent-color);
        overflow: hidden;
        padding: 5px 8px 4px 8px;
    }

    .card.card--promo .found_description {
        color: var(--promo-card-text-color, white);
        flex-basis: 100%;
    }

</style>

<div class="card desktop-col-2 user-select-none flex-column gap-05 pointer" on:click={() => toggleDetailsScreen(record)}>

    <div class="media-block" style:height="{cardHeight || 'unset'}">
        {#if (record?.media?.length > 0)}
            <Image src={'_196/' + media?.name}
                   tenantKey={media?.ref || tenantKey}
                   hasVideo={ (record.media || []).find(x => x.type === 'video') !== undefined }
                   scaleOnHover={true}
                   imgHeight="{cardHeight}"
                   aspectRatio="4 / 5"
                   alt={record?.name || ''}>
            </Image>
        {:else }
            <Image imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {/if}

        {#if (record.label !== null && record.label !== undefined)}
            <div class="label">
                { record.label }
            </div>
        {/if}

    </div>

    <div class="flex-column gap-05">
        <h4 class="record-name" class:record-name--small={record?.name?.length > 30} on:click={() => {nutritionalOpen = !nutritionalOpen;}}>
            {record.name || ''}
        </h4>
        <Price record={record}
               priceItem={record.prices[0]}
               publishConfig={publishConfig}
               spaceBetween={true}
               on:add={(e) => dispatch('addToCart', e.detail)}
               on:remove={(e) => dispatch('removeFromCart', e.detail)}
        >
        </Price>
    </div>

    {#if (record._found_desc && record.promoted?.enabled === true)}
        <div class="found_description fs-90 lh-110 flex-fill">
            {@html record._found_desc }
        </div>
    {/if}

    <div class="card-info-block" style="display: none;">

        {#if (record.prices && record.prices.length > 0)}
            <div class="prices-block flex-between">
                <div>
                    {#if (record.prices[0].oldPrice !== null && record.prices[0].oldPrice !== undefined)}
                        <span class="price price--old">{ record.prices[0].oldPrice }</span>
                    {/if}

                    {#if (record._minPrice !== undefined)}
                        <span class="from">{$t('price.from')} </span>
                        <span class="price price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                            <span>{record._minPrice}</span>
                            <span>{publishConfig?.currency || ''}</span>
                        </span>
                    {:else}
                        {#if (record.prices[0].price !== null && record.prices[0].price !== undefined)}
                            <span class="price  price-pair" class:price-pair--rev={publishConfig?.currency === '$'}>
                                <span>{record.prices[0].price}</span>
                                <span>{publishConfig?.currency || ''}</span>
                            </span>
                        {/if}
                    {/if}

                    {#if (record.prices[0].weight)}
                        <span class="separator">/</span>&nbsp;<span class="weight">{record.prices[0].weight}</span>
                    {/if}
                </div>
                <div>
                    {#if record.isFavorite}
                        <span class="favorite">
                            <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
                        </span>
                    {/if}
                </div>
            </div>
        {/if}

        {#if ($optionsStore.showMealTitleAtFrontPage)}
            <div class="record-title">
                {record.name || ''}
            </div>

            {#if (record._found_desc && !record.promoted?.enabled)}
            <div class="found_description fs-90 lh-110">
                {@html record._found_desc }
            </div>
            {/if}
        {/if}
    </div>

    {#if (record._found_desc && record.promoted?.enabled === true)}
        <div class="found_description fs-90 lh-110 flex-fill">
            {@html record._found_desc }
        </div>
    {/if}

</div>
